import styles from "./Labels.module.css";
import MetroNet from "./MetroNet";

const Logo = () => {
  return (
    <div className={styles.logo}>
      <MetroNet />
    </div>
  );
};

export default Logo;
